import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import Folder from '../store/schema/Folder';
import FolderStore from '../store/schema/FolderStore';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

export default function folderHasChildWithName(
    folders: FolderStore,
    folderDisplayName: string,
    parentFolderId: string | DistinguishedFolderIdName
): boolean {
    let parentFolder: Folder;

    if (typeof parentFolderId == 'string') {
        parentFolder = folders.folderTable.get(parentFolderId);
    } else {
        parentFolder = folders.folderTable.get(folderNameToId(parentFolderId));
    }

    let childFolderIds: string[] = parentFolder.childFolderIds;
    let folderDisplayNameLowerCase = folderDisplayName.toLowerCase();
    for (let i = 0; i < childFolderIds.length; i++) {
        let childFolderId = childFolderIds[i];
        let childFolder = folders.folderTable.get(childFolderId);
        if (childFolder && childFolder.DisplayName.toLowerCase() == folderDisplayNameLowerCase) {
            return true;
        }
    }

    return false;
}
